<div class="au-table">
	<!-- Table wrapper with fixed height and scrollable content -->
	<div class="table-wrapper nice-scroll visible-scroll">
		<table
			[ngClass]="
				openedFromActionCenter()
					? 'action-center-width table-container'
					: 'table-container'
			"
			class="cmms-table"
			mat-table
			[dataSource]="tableData()"
		>
			<!-- checkbox column -->
			<ng-container matColumnDef="select" [sticky]="numOfStickyColumns > 0">
				<th mat-header-cell class="table-checkbox" *matHeaderCellDef>
					<mat-checkbox
						class="au-checkbox"
						color="primary"
						(change)="tableBulkCheckboxHandler($event, tableData())"
						[checked]="tableSelectedData?.hasValue() && isAllSelected()"
						[indeterminate]="tableSelectedData?.hasValue() && !isAllSelected()"
					>
					</mat-checkbox>
				</th>
				<td mat-cell *matCellDef="let item" (click)="$event.stopPropagation()">
					<mat-checkbox
						class="au-checkbox"
						color="primary"
						[checked]="tableSelectedData?.isSelected(item)"
						(change)="tableCheckboxHandler($event, item)"
					>
					</mat-checkbox>
				</td>
			</ng-container>
			<!-- end checkbox -->
			<!-- Owner Column -->
			@for (column of tableColumns; track column; let idx = $index) {
				<ng-container [matColumnDef]="column.head" [sticky]="idx < numOfStickyColumns">
					<th mat-header-cell *matHeaderCellDef>
						<span>
							@switch (column.customData?.customTableHeader) {
								@case ('classification') {
									<div>
										<classification-types-menu
											[selectedClassification]="column.customData.filteredBy"
										></classification-types-menu>
									</div>
								}
								@default {
									<div>
										<span [class.hideColumn]="column.head === 'emty_head'">
											{{ column.head | translate }}
										</span>
									</div>
								}
							}
						</span>
					</th>
					<td mat-cell *matCellDef="let item">
						<div class="flex-center" [class.action]="column.type === COLUMN_TYPES.ACTION">
							@if (column.type === COLUMN_TYPES.ACTION) {
								<au-table-actions-column
									[column]="column"
									[data]="item"
									(remove)="cmmsDelete.emit($event)"
								>
								</au-table-actions-column>
							} @else {
								<au-table-cmms-column
									(selectElement)="selectElement($event)"
									[usePlaceholderForAvatar]="usePlaceholderForAvatar"
									[column]="column"
									[item]="item"
								></au-table-cmms-column>
							}
						</div>
					</td>
				</ng-container>
			}

			<!-- Actions Column -->
			@if (actions.length) {
				<ng-container matColumnDef="actions">
					<th mat-header-cell *matHeaderCellDef>{{ 'actions' | translate }}</th>
					<td mat-cell *matCellDef="let item">
						<div class="actions">
							@for (action of actions; track action) {
								<button
									[class]="tableActions.get(action)?.class"
									(click)="$event.stopPropagation(); tableActions.get(action).click(item)"
								>
									<mat-icon
										[class]="tableActions.get(action).matIconClass"
										[svgIcon]="tableActions.get(action).icon"
									></mat-icon>
								</button>
							}
						</div>
					</td>
				</ng-container>
			}

			<tr mat-header-row *matHeaderRowDef="head; sticky: true"></tr>
			<tr
				mat-row
				class="au-table-row"
				[class.cursor-pointer]="isClickableRow"
				(click)="tableRowClicked(row)"
				*matRowDef="let row; columns: head; let i = index"
				[ngClass]="
					row?.pk === activeElement?.pk || (i === index() && openedFromActionCenter())
						? 'active'
						: 'inactive'
				"
			></tr>
		</table>
	</div>
</div>
